import { Layout } from "components2";
import {
    DEFAULT_ROUTE, O2APPOINTMENT_INFO
} from "constants/route";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hasAppointment } from "services/api-service2";

const ZERO = 0;

// Only UAT or PRD will call this page
// This should only call after login successful
// This page is to do necessary checking before redirecting to different pages according to workflow logic.
// setIsLogin & changeNric will invoke in header 
// close-acct service is not using any login info
// Possible next pages are;
// 1. O2APPOINTMENT_INFO (if already ack & the ic have the appointment)
// 2. O2Form (when nothing else to do)
export default function O2SingPassCallBack() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { nric } = useSelector((state) => state.appointment);
  const { ack, hasApptNricFin, hasApptPassport } = useSelector((state) => state.o2Appointment);

  useEffect(() => {
    if(window.dbg0) {
      debugger;
    }
    console.log("##spcb", isLogin, nric);
    if(isLogin && nric) {
      if(ack)  {
        // null (don't have appointment) | { createdUsingSingpass, hasApptEmail, hasApptMobile, hasApptNricFin, hasApptPassport } (have appointment)
        hasAppointment(nric).then(appt=>{
          if(appt === null) {
            navigate(DEFAULT_ROUTE);
          } else {
            navigate(O2APPOINTMENT_INFO);
          }
        });
      } else {
        navigate(DEFAULT_ROUTE);
      }
    }
  }, [isLogin, nric]);


    return (
      <Layout subHeader={"How can we help?"} mainText={
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">CONTACT US</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
        <div className="form-box">
          <div className="center my-5">
            <div
              className="my-5 mx-3 text-center"
              style={{ paddingLeft: 60, paddingRight: 60 }}
            >
              Loading...   
            </div>
          </div>
        </div>
      </Layout>
    );

}
